module.exports = function(app) {
    app.directive('spouseAndDomesticPartnerValidation', ['employee', function(employee) {

        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                dependent: '=spouseAndDomesticPartnerValidation',
                employee: '=spouseValidationEmployee',
                isEdit: '=?onEditPage'
            },

            link: function (scope, elm, attrs, ctrl) {

                ctrl.$validators.spouseAndDomesticPartnerValidation = function(modelValue, viewValue) {
                    var isSpouseOrPartner = function(value) {
						return value === '01' || value === '29';
					};

                    var isSpouseOrPartnerByDependent = function(dep){
                        if(dep.relationshipCode === '01' || dep.relationshipCode === '29'){
                            var anyActiveLobs = false;
                            var today = new Date();
                            if (Array.isArray(dep.memberCoverages)) {
                                dep.memberCoverages.forEach(function(coverage) {
                                    if (Array.isArray(coverage.memberLobs)) {
                                        coverage.memberLobs.forEach(function(lob) {
                                            if (!lob.coverageEndDate || lob.coverageEndDate > today) {
                                                anyActiveLobs = true;
                                            }
                                        });
                                    }
                                });
                            }
                            return anyActiveLobs;
                        } else{
                            return false;
                        }
                    };

					var count = scope.employee.data.dependents.filter(function(d) {
                        if (d === scope.dependent) {
                            // if the input that just changed is for an existing dependent, don't count them twice...
                            return false;
                        }
						return scope.isEdit? isSpouseOrPartnerByDependent(d): isSpouseOrPartner(d.relationshipCode);
					}).length;

					if(scope.isEdit){
					    //edit employee, validation along with lobs
                        if (isSpouseOrPartnerByDependent(scope.dependent)) { ++count; }
                    } else{
                        //enrollment, strict validation on spouses
                        if (isSpouseOrPartner(scope.dependent)) { ++count; }
                    }
                    return count < 2;
                };
            }
        };
    }]);
};

